import React, { Component } from "react";
import styled from "styled-components";
import {CirclePicker} from 'react-color'

import "./App.css";
import SearchList from "./SearchList";

const Main = styled.div`
width:450px;
height: 80vh;
  display:flex;
  flex-direction:column;
  border-radius:15px;
p{color:white;
    ::before{
        width:100%;
        height:1px;
        border:1px solid black;
    }
   
}
@media (max-width:500px) {

width:375px;
height: 100vh;
margin-bottom:20px;


}
@media (max-width:320px) {

width:320px;
height: 120vh;


}
`;

const Input = styled.input`
padding:10px ;
margin:20px 20px 10px 20px;
border-radius:10px;

`


export class Info extends Component {
  render() {
    return (
      <div >
        <Main>

        <Input placeholder="Şarkı veya Sanatçı Adı" onChange={(e)=>this.props.getspotify(e)}/>
<div style={{position:"relative" ,zIndex:"1"}}>
  <SearchList item={this.props.search} setSearch={this.props.setSearch}/>
</div>


        <Input placeholder="Şarkı Adı"/>
        <Input placeholder="Sanatçı"/>
        
        <p style={{color:"#E35F21",paddingTop:"30px"}}>Veya kendi fotoğrafınızı ekleyin</p>
        <Input placeholder="Şarkı Adı" name="track" onChange={(e)=>this.props.setAlbum(e)}/>
        <Input placeholder="Sanatçı"name="name" onChange={(e)=>this.props.setAlbum(e)}/>
        <span style={{  margin:"20px auto",zIndex:"0"}}> 
        <p>Renginizi Belirleyin</p>

        <CirclePicker  colors={['#E27300', '#FCC400', '#EEEEEE', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', ]}  onChange={(color)=>this.props.setAlbum(color)}/>
        </span>
        <form  >
              <p>Resim Eklemek için Tıklayın</p>
              <input type="file" multiple name="image" onChange={(e)=>this.props.setAlbum(e)}/>
        </form>
        </Main>
      </div>
    );
  }
}

export default Info;
